/* Homepage polish: scroll-reveal + stat counter gating.
 * Uses IntersectionObserver; degrades to instant-visible if unsupported. */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Sections we auto-tag for scroll-reveal (no markup edits required).
  var REVEAL_TARGETS = [
    '.main-banner .caption-box',
    '.sction-education-classrooms .section-title',
    '.sction-training .section-title',
    '.sction-training .counter',
    '.sction-left-content .mainrow',
    '.sction-right-content .mainrow',
    '.section-dreamrank .section-title',
    '.sction-partners .section-title'
  ];

  // Children that stagger inside a parent.
  var STAGGER_GROUPS = [
    { parent: '.section-dreamrank .mainrow', children: '.services-block' },
    { parent: '.sction-training .counter',   children: 'li' }
  ];

  function tagReveal(el) {
    if (!el || el.hasAttribute('data-reveal')) return;
    el.setAttribute('data-reveal', '');
  }

  function tagStagger(parentSel, childSel) {
    document.querySelectorAll(parentSel).forEach(function (parent) {
      var kids = parent.querySelectorAll(childSel);
      kids.forEach(function (kid, i) {
        if (kid.hasAttribute('data-reveal-child')) return;
        kid.setAttribute('data-reveal-child', '');
        kid.style.setProperty('--reveal-delay', (i * 110) + 'ms');
      });
    });
  }

  function reveal(el) {
    el.classList.add('is-visible');
  }

  function setupRevealObserver() {
    if (prefersReducedMotion) {
      document
        .querySelectorAll('[data-reveal], [data-reveal-child]')
        .forEach(reveal);
      return;
    }
    if (!('IntersectionObserver' in window)) {
      document
        .querySelectorAll('[data-reveal], [data-reveal-child]')
        .forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }
    );

    document
      .querySelectorAll('[data-reveal], [data-reveal-child]')
      .forEach(function (el) { io.observe(el); });
  }

  /* Gate the stat counter (.start-number) so it animates once on scroll-in,
   * not immediately on page load. The layout already pre-animates them via
   * jQuery; we stop that animation, reset the displayed value to 0, and
   * re-run the count-up when the counter group enters the viewport. */
  function setupCounters() {
    var counters = document.querySelectorAll('.start-number');
    if (!counters.length) return;

    // Capture the final value from the rendered text (may already have been
    // modified mid-animation by the inline jQuery, so read the data-target
    // if present, else parse the current text).
    counters.forEach(function (node) {
      if (!node.hasAttribute('data-target')) {
        var raw = (node.textContent || '').trim();
        // Strip anything non-numeric except the decimal point.
        var parsed = parseFloat(raw.replace(/[^0-9.\-]/g, ''));
        if (isNaN(parsed)) parsed = 0;
        node.setAttribute('data-target', String(parsed));
      }
    });

    // Stop the jQuery animation if jQuery is available, and reset to 0.
    if (window.jQuery) {
      window.jQuery('.start-number').stop(true, false).each(function () {
        this.textContent = '0';
      });
    } else {
      counters.forEach(function (n) { n.textContent = '0'; });
    }

    if (prefersReducedMotion) {
      counters.forEach(function (n) {
        n.textContent = n.getAttribute('data-target');
      });
      return;
    }

    var group = document.querySelector('.sction-training .counter');
    if (!group) return;

    function animateCount(el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = (el.getAttribute('data-target').split('.')[1] || '').length;
      var duration = 1800;
      var startTime = null;

      function step(ts) {
        if (!startTime) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        // Ease-out cubic for a natural settle.
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = target * eased;
        el.textContent = decimals
          ? current.toFixed(decimals)
          : Math.floor(current).toLocaleString('en-US');
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = decimals
          ? target.toFixed(decimals)
          : Math.floor(target).toLocaleString('en-US');
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
      return;
    }

    var cio = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            counters.forEach(animateCount);
            obs.disconnect();
          }
        });
      },
      { threshold: 0.35 }
    );
    cio.observe(group);
  }

  /* Subtle vertical parallax on the hero image. The image moves down at a
   * fraction of the scroll speed, so it appears to drift slower than the rest
   * of the page. Companion CSS makes the img ~130% of container height so
   * translation never exposes empty edges. */
  function setupBannerParallax() {
    var img = document.querySelector('.main-banner .banner-img img');
    if (!img) return;
    if (prefersReducedMotion) return;

    var banner = img.closest('.main-banner');
    if (!banner) return;

    var ticking = false;
    var FACTOR = 0.35;

    function update() {
      ticking = false;
      var rect = banner.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      var scrolled = Math.max(-rect.top, 0);
      var translate = scrolled * FACTOR;
      img.style.transform = 'translate3d(0,' + translate.toFixed(2) + 'px,0)';
    }

    function schedule() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  function init() {
    REVEAL_TARGETS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(tagReveal);
    });
    STAGGER_GROUPS.forEach(function (g) { tagStagger(g.parent, g.children); });

    setupRevealObserver();
    setupCounters();
    setupBannerParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
